import React, { useState } from "react"
import BifrostButton from "../../../../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../../../../Components/BifrostPageComponent/BifrostModal/BifrostModal"
import BifrostConfirmModalActions from "../../../../../../Components/BifrostPageComponent/BifrostModal/BifrostModalActions/BifrostConfirmModalActions"
import Loader from "../../../../../../Components/BifrostPageComponent/Loader/Loader"
import { useDeleteData } from "../../../../../../Hooks/FetchHooks/DeleteDataService/useDeleteData"
import DeleteGroupPage from "./DeleteGroupPage"

const DeleteGroupModal = ({ name, id, refreshGroups }) => {
	const [showErrorMessage, setShowErrorMessage] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const { isLoading, deleteItem } = useDeleteData()

	const deleteHandler = () => {
		deleteItem("/api/v2/group/", id, refreshGroups)
			.then(() => {
				setOpenModal(false)
				setShowErrorMessage(false)
			})
			.then(() => {
				if (refreshGroups) {
					refreshGroups()
				}
			})
			.catch((e) => {
				console.log(e)
				setShowErrorMessage(true)
			})
	}

	const cancelHandler = () => {
		setShowErrorMessage(false)
		setOpenModal(false)
		refreshGroups()
	}

	return (
		<>
			<BifrostModal
				title={"Delete Group"}
				open={openModal}
				setOpen={setOpenModal}
				closeOnEscape={!isLoading}
				closeOnDimmerClick={!isLoading}
				trigger={<BifrostButton color="red"> Delete </BifrostButton>}
				modalPage={isLoading ? <Loader backgroundColor="white" inverted height="1px" minHeight="100px" /> : <DeleteGroupPage name={name} showDeleteErrorMessage={showErrorMessage} />}
				modalActions={<BifrostConfirmModalActions loading={isLoading} confirmHandler={() => deleteHandler()} cancelHandler={() => cancelHandler()} />}
			/>
		</>
	)
}

export default DeleteGroupModal
